export const formatoUrl = (texto) => {
    let resultado = encodeURI(texto)
    return resultado
}